import * as React from "react"
import { Fragment } from "react"
import { createRoot } from "react-dom/client"
import { HelmetProvider } from "react-helmet-async"
import { BrowserRouter } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"

import { register, unregister } from "./serviceWorker"

// Same entry as @ui-seeker/app 0.44.11: helmet, router and the toast container around the app
export default function renderApp(App, {
    documentID = "root",
    Helmet = HelmetProvider,
    Router = BrowserRouter,
    Notifier = ToastContainer,
    notifierConfig = {},
    useServiceWorker = true,
} = {}) {
    const HelmetApp = Helmet ? Helmet : Fragment
    const RouterApp = Router ? Router : Fragment

    createRoot(document.getElementById(documentID)).render(
        <HelmetApp>
            <RouterApp>
                {Notifier ? <Notifier closeOnClick stacked {...notifierConfig}/> : null}
                <App/>
            </RouterApp>
        </HelmetApp>
    )

    if (useServiceWorker) {
        if (process?.env?.USE_SW === "TRUE") register()
        else unregister()
    }
}
